import { Grid2, Typography } from '@mui/material'
import React from 'react'
import SelectChipIndicator from '../SelectChipIndicator'
import PropTypes from 'prop-types'

const IndicatorHeaderDialog = ({
    current={},
    previous={},
    status={},
    onStatusChange=() => {},
    unit='',
    offset=0,
    text='',
    options,
}) => {
    return (
        <Grid2
            container
            size={12}
        >
            <Grid2 container size={'grow'} alignItems={'end'}>
                {text &&
                    <Typography variant='h5'>
                        {text}
                    </Typography>
                }
            </Grid2>
            <Grid2
                container
                direction={'column'}
                sx={{ ml: 'auto' }}
                width={`calc(calc(100% - ${offset}px)/10)`}
                minWidth={100}
                justifyContent={'space-between'}
            >
                <Typography> {previous.year || '/'} </Typography>
                <Typography
                    variant='h5'
                >
                    {previous.value || 0}
                </Typography>
            </Grid2>
            <Grid2
                container
                direction={'column'}
                sx={{ ml: 'auto' }}
                width={`calc(calc(100% - ${offset}px)/10)`}
                minWidth={100}
                justifyContent={'space-between'}
            >
                <Typography> {current.year || '/'} </Typography>
                <Typography
                    variant='h5'
                    color='#3548b0'
                    fontWeight={'bold'}
                >
                    {current.value || 0}
                </Typography>
            </Grid2>
            <Grid2
                container
                width={`calc(calc(100% - ${offset}px)/5)`}
                direction={'column'}
            >
                <Grid2
                    container
                    justifyContent={'end'}
                >
                    <SelectChipIndicator
                        right
                        indicatorStatus={status}
                        onChange={onStatusChange}
                        options={options}
                    />
                </Grid2>
                <Typography>
                    {unit}
                </Typography>
            </Grid2>
        </Grid2>
    )
}

IndicatorHeaderDialog.propTypes = {
    current: PropTypes.shape({
        year: PropTypes.string,
        value: PropTypes.number,
    }),
    previous: PropTypes.shape({
        year: PropTypes.string,
        value: PropTypes.number,
    }),
    status: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    onStatusChange: PropTypes.func,
    unit: PropTypes.string,
    offset: PropTypes.number,
    text: PropTypes.string,
    options: PropTypes.shape([]),
}

export default IndicatorHeaderDialog